const OneTinSoldier = [
	'[VERSE 1]',
	'Listen children to a story, that was written long ago..',
	'about a kingdom, on a mountain, and the valley folk below.',
	'On the mountain was a treasure, buried deep beneath a stone..',
	"And the valley people swore, they'd have it for their very own.",
	'',
	'[CHORUS]',
	'Go ahead and hate your neighbor, go ahead and cheat a friend.',
	'Do it in the name of Heaven, you can justify it in the end.',
	"There won't be any trumpets blowing, come the Judgement Day..",
	'On the bloody morning after..one tin soldier rides away.',
	'',
	'[VERSE 2]',
	'So, the people of the valley, sent a message up the hill..',
	"asking for the buried treasure, tons of gold for which they'd kill.",
	"Came an answer from the kingdom, 'With our brothers we will share,",
	"all the secrets of our mountain..all the riches buried there.'",
	'',
	'[VERSE 3]',
	"Now the valley cried in anger, 'Mount your horses, draw your sword!'",
	"And they killed the mountain people, sure they'd won their just reward.",
	'Now they stood beside the treasure, on the mountain dark and red..',
	"turned the stone and looked beneath it..'Peace on Earth,' was all it said.",
	'',
	'[CHORUS]',
	'Go ahead and hate your neighbor, go ahead and cheat a friend.',
	'Do it in the name of Heaven, you can justify it in the end.',
	"There won't be any trumpets blowing, come the Judgement Day..",
	'On the bloody morning after..one tin soldier rides away.',
	'',
	'[OUTRO]',
	'Go ahead and hate your neighbor, go ahead and cheat a friend.',
	'Do it in the name of Heaven, you can justify it in the end.',
	"There won't be any trumpets blowing, come the Judgement Day..",
	'On the bloody morning after..one tin soldier rides away.',
];

export default OneTinSoldier;
